import { NotificationsTabs } from '../components/notifications/NotificationsSettings/NotificationsTabs'

export function NotificationsSettingsPage() {
  return <NotificationsTabs />
}
